import { useIdentityContext } from '@dark-portal/frontend-identity/src/features/app/features/identity/store/store';
import React from 'react';

import { Loader } from '@/src/features/_components/loader/Loader';
import { AppContent } from '@/src/features/app/features/content/Content';
import { UserConfigurationContextProvider } from '@/src/features/app/store/userConfiguration/Provider';

export function AppWrapper() {
  const initialized = useIdentityContext((store) => store.initialized);

  if (!initialized) {
    return <Loader />;
  }

  return (
    <UserConfigurationContextProvider>
      <AppContent />
    </UserConfigurationContextProvider>
  );
}
